export default {
  isLoading: false,
  error: null,
  banks: [],
}
